import { NO_DATE } from '@/pages/opinion/constants';
import React from 'react';
import { ErrorTip, StatusTip } from 'tea-component';
import { useIntl } from 'umi';

export default function Tips({
  loadingText = '',
  loading = false,
  apiError = false,
  noData = false,
  children = null,
  noDataStyle = {},
  onRetry,
  retryText,
  noDateText = NO_DATE.SELECTION,
  className,
  style,
  noDataClass = '',
}: {
  loadingText?: string;
  loading?: boolean;
  apiError?: boolean;
  noData?: boolean;
  children?: JSX.Element | string | null;
  className?: string;
  style?: any;
  retryText?: string;
  onRetry?: () => void;
  noDateText?: string;
  noDataStyle?: any;
  noDataClass?: string;
}) {
  let element: JSX.Element | null | string = children;
  const { formatMessage } = useIntl();
  if (loading) {
    element = <StatusTip loadingText={loadingText} status="loading" />;
  } else if (apiError) {
    const text = formatMessage({ id: NO_DATE.ERROR });
    element = onRetry ? (
      <span onClick={(e) => e.stopPropagation()}>
        <ErrorTip
          errorText={retryText ? retryText : text}
          onRetry={() => onRetry()}
        />
      </span>
    ) : (
      text
    );
  } else if (noData) {
    element = (
      <span>
        {typeof noDateText === 'string'
          ? formatMessage({ id: noDateText || NO_DATE.EMPTY })
          : noDateText}
      </span>
    );
  }

  return (
    <span
      className={`${className} ${noData ? noDataClass : ''}`}
      style={{ ...style, ...(noData ? noDataStyle : {}) }}
    >
      {element}
    </span>
  );
}
